module.exports = __webpack_public_path__ + "static/media/Admin-13.c37293e8.png";